import { styled } from "styled-components";

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgb(255, 81, 96);
  cursor: pointer;
  font-size: 24px;
  width: 65px;
  height: 65px;
`;
